export * from "-!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/stylus-loader/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserView.vue?vue&type=style&index=0&id=4d74474a&lang=stylus&"


//////////////////
// WEBPACK FOOTER
// ./src/views/UserView.vue?vue&type=style&index=0&id=4d74474a&lang=stylus&
// module id = 621
// module chunks = 8